module.exports = "https://deal-img.imgix.net/consumer/modern/chrome.0d846ede.png";